module.exports = require("bson");